import { IconCard as AntdIconCard } from "@empglabs/backoffice-ui-kit"

const IconCard = props => {
  return <AntdIconCard {...props} />
}
export default IconCard
